var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".soundcloud-icon-circle-1{fill:#f70;}.soundcloud-icon-circle-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-1",
    d: "M144.24,22.5a22.5,22.5,0,1,0-6.59,15.91A22.5,22.5,0,0,0,144.24,22.5Z",
    transform: "translate(-99.24 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M101.56,21.72a.17.17,0,0,0-.16.16l-.3,2.26.3,2.22a.17.17,0,0,0,.16.16.17.17,0,0,0,.16-.16h0l.35-2.22-.35-2.26a.17.17,0,0,0-.16-.16Z",
    transform: "translate(-99.24 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M103.23,20.49a.17.17,0,0,0-.34,0l-.4,3.65.4,3.57a.17.17,0,0,0,.34,0l.45-3.57-.45-3.65Z",
    transform: "translate(-99.24 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M109.53,17.12a.31.31,0,0,0-.31.3l-.32,6.72.32,4.34a.31.31,0,0,0,.62,0h0l.36-4.34-.36-6.72A.32.32,0,0,0,109.53,17.12Z",
    transform: "translate(-99.24 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M106.27,19.45a.24.24,0,0,0-.24.23l-.36,4.45.36,4.31a.24.24,0,0,0,.48,0l.41-4.31-.41-4.45A.25.25,0,0,0,106.27,19.45Z",
    transform: "translate(-99.24 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M112.84,28.78a.38.38,0,0,0,.38-.37l.31-4.27-.31-8.94a.38.38,0,0,0-.75,0l-.28,8.94.28,4.27A.38.38,0,0,0,112.84,28.78Z",
    transform: "translate(-99.24 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M119.62,28.8a.52.52,0,0,0,.52-.51h0l.22-4.15-.22-10.33a.52.52,0,0,0-1,0l-.19,10.32.19,4.15A.52.52,0,0,0,119.62,28.8Z",
    transform: "translate(-99.24 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M116.2,28.79a.45.45,0,0,0,.45-.44h0l.26-4.2-.27-9a.45.45,0,0,0-.89,0l-.24,9,.24,4.2a.45.45,0,0,0,.45.44Z",
    transform: "translate(-99.24 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M107.89,28.75a.28.28,0,0,0,.27-.27l.38-4.34L108.16,20a.27.27,0,0,0-.55,0l-.34,4.13.34,4.34A.28.28,0,0,0,107.89,28.75Z",
    transform: "translate(-99.24 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M104.66,28.51a.21.21,0,0,0,.2-.2l.43-4.17-.43-4.33a.21.21,0,0,0-.2-.2.21.21,0,0,0-.2.2l-.38,4.33.38,4.17a.21.21,0,0,0,.2.2Z",
    transform: "translate(-99.24 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M117.91,15a.48.48,0,0,0-.48.48l-.22,8.68.22,4.18a.48.48,0,0,0,1,0h0l.24-4.18-.24-8.68a.48.48,0,0,0-.48-.48Z",
    transform: "translate(-99.24 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M111.18,28.79a.35.35,0,0,0,.34-.34l.34-4.31-.34-8.25a.34.34,0,0,0-.69,0l-.3,8.25.3,4.31A.35.35,0,0,0,111.18,28.79Z",
    transform: "translate(-99.24 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M114.93,28.39h0l.29-4.24-.29-9.24a.41.41,0,0,0-.82,0l-.26,9.24.26,4.24a.41.41,0,0,0,.82,0h0Z",
    transform: "translate(-99.24 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M136.75,18.81a5,5,0,0,0-1.93.39,8.82,8.82,0,0,0-8.79-8,8.94,8.94,0,0,0-3.2.6c-.38.15-.48.3-.48.59V28.22a.61.61,0,0,0,.54.59h13.86a5,5,0,0,0,0-10Z",
    transform: "translate(-99.24 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "soundcloud-icon-circle-2",
    d: "M121.33,12.33a.56.56,0,0,0-.55.55l-.23,11.26.23,4.09a.55.55,0,0,0,1.1,0h0l.25-4.09-.25-11.26a.56.56,0,0,0-.55-.55Z",
    transform: "translate(-99.24 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.77c0f9edba2eeff72db1baaf4cc084d0.svg";
export { ForwardRef as ReactComponent };